export const DS_PASSWORD_FIELD_CLASSES = {
  Root: "ds-password-field",
  Input: "ds-password-field__input",
  ToggleButton: "ds-password-field__toggle-button",
} as const;
